var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 5 3.75 3.75M5.5 5H3l-.833-2.5L3 1.667l2.5.833V5zm11.05-2.716-2.19 2.19c-.33.33-.495.495-.557.685a.833.833 0 0 0 0 .516c.062.19.227.355.557.685l.197.198c.33.33.495.495.686.556a.833.833 0 0 0 .515 0c.19-.061.355-.226.685-.556l2.048-2.049a4.583 4.583 0 0 1-5.133 6.238c-.405-.08-.607-.12-.73-.108a.697.697 0 0 0-.31.095c-.11.058-.218.167-.437.386l-5.964 5.964a1.768 1.768 0 1 1-2.5-2.5l5.964-5.965c.218-.218.328-.327.386-.436a.697.697 0 0 0 .094-.31c.013-.123-.027-.326-.107-.73a4.583 4.583 0 0 1 6.796-4.858zM10.5 12.5l4.584 4.584a1.768 1.768 0 0 0 2.5-2.5l-3.77-3.77a4.567 4.567 0 0 1-.78-.143c-.324-.09-.68-.025-.917.213L10.5 12.5z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool02);
export default __webpack_public_path__ + "static/media/tool02.e09be6bf4f23ac338edf1c0a5c0f0a9e.svg";
export { ForwardRef as ReactComponent };